import { BundleId } from "../store";
import { updateMapSettings } from "./updateMapSettings";

export function updateActiveLayer(bundleId: BundleId) {
  updateMapSettings("activeLayer", bundleId);
}
